import React from 'react';
import { useNavigate } from 'react-router-dom';
import './scss/errorBoundary.scss';
import { CButton } from '@coreui/react';

// Higher Order Component to provide navigate function to class component
const withNavigation = (Component) => {
    return props => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
};

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        console.error("Caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary-container">
                    <div className="error-boundary-content">
                        <h1 style={{fontSize:"40px"}}>Oops! Something went wrong</h1>
                        <p>We're sorry for the inconvenience. The application encountered an unexpected error.</p>
                        <CButton 
                            className="btn btn-dark" 
                            size='lg'
                            onClick={() => {
                                this.props.navigate(-1);
                                setTimeout(() => window.location.reload(), 100);
                            }}
                        >
                            Go Back
                        </CButton>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default withNavigation(ErrorBoundary);
